import { useEffect } from 'react';
import { useThree } from '@react-three/fiber';
import { Box3, Vector3 } from 'three';

interface CenteredCameraProps {
  boundingBox: Box3;
}

function CenteredCamera({ boundingBox }: CenteredCameraProps) {
  const { camera } = useThree();

  useEffect(() => {
    if (boundingBox) {
      const size = new Vector3();
      boundingBox.getSize(size);

      const maxDimension = Math.max(size.x, size.y, size.z);
      const cameraDistance = maxDimension * 2;

      const x = cameraDistance * Math.cos(4.72);
      const y = cameraDistance * Math.sin(4.72);
      const z = cameraDistance / 2;

      camera.position.set(x, y, z);
      camera.lookAt(0, 0, 0);
      camera.up.set(0, 0, 1);
      camera.updateProjectionMatrix();
    }
  }, [camera, boundingBox]);

  return null;
}

export default CenteredCamera;
